  <div class="container-list-body">
    <div class="row">
    <div class="col-md-3 mb-md-2 px-50 mb-12" *ngFor="let functionalitiesModuleRole of listFunctionalities">
      <app-functionalities-item [funcionalities]="functionalitiesModuleRole"></app-functionalities-item>
    </div>
  </div>
  </div>
